import { KeyboardShortcut } from "@nova/constants"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { Fragment } from "react"
import Image from "next/image"

export const CreationMenuTab = ({
    Icon,
    iconUrl,
    title,
    shortcut,
    iconClasses,
    onClick,
    isSelected,
    isDisabled,
    isPaywalled,
    ...rest
}: {
    Icon?: Icons.IconComponent
    iconUrl?: string
    title: string
    shortcut?: KeyboardShortcut
    iconClasses?: string
    onClick?: () => void
    isSelected?: boolean
    isDisabled?: boolean
    isPaywalled?: boolean
}) => {
    if (!Icon && !iconUrl) throw Error("Must provide either an icon or iconUrl.")

    return (
        <div
            className={classNames("group flex gap-3 pl-2 h-8 items-center rounded-lg", {
                "text-gray-100": !isSelected,
                "hover:bg-gray-700 hover:text-gray-0": !isSelected && !isDisabled,
                "text-gray-0 bg-gray-700": isSelected && !isDisabled,
                "cursor-pointer": !isDisabled,
                "opacity-30 saturate-50 cursor-not-allowed": isDisabled,
            })}
            onClick={!isDisabled ? onClick : undefined}
            {...rest}
        >
            {Icon ? (
                <Icons.SmallIcon Icon={Icon} className={iconClasses} />
            ) : iconUrl ? (
                <div className="w-5 h-5">
                    <Image
                        src={iconUrl}
                        alt={title}
                        width={20}
                        height={20}
                        className="w-full h-full object-contain"
                        priority
                    />
                </div>
            ) : (
                <Icons.SmallIcon Icon={Icons.QuestionMark} className={iconClasses} />
            )}
            <h5>{title}</h5>
            {isPaywalled && (
                <div className="flex flex-grow justify-end mr-1.5">
                    <Icons.Icon
                        Icon={Icons.Lock}
                        className="text-white-400 h-5 w-5 bg-blue-900 rounded-md p-0.5 group-hover:bg-transparent group-hover:text-blue-200"
                    />
                </div>
            )}
            {shortcut && (
                <div className="flex flex-grow justify-end mr-3">
                    {shortcut.letters.map((letter, i) => (
                        <Fragment key={i}>
                            {i > 0 && (
                                <Icons.ExtraSmallIcon
                                    Icon={Icons.Plus}
                                    className="text-white-400"
                                />
                            )}
                            <small className="text-white-400">{letter}</small>
                        </Fragment>
                    ))}
                </div>
            )}
        </div>
    )
}
